<div style="background-color: #0e2b33">
  <div class="container-fluid w-100 mx-auto pt-3" style="max-width: 1500px">
    <div class="row px-3 py-2 mb-4 ft-top">
      <div class="col-12 col-md-6 px-0">
        <div
          class="h-100 d-flex align-items-center justify-content-start justify-content-lg-start mb-3 mb-lg-0"
        >
          <div>
            <pla-platex-direct
              class="platex-logo"
              [colour]="'white'"
              [direct]="false"
              [platePortal]="true"
            ></pla-platex-direct>
          </div>
        </div>
      </div>
      <div *ngIf="woyp" class="col-12 col-md-6 px-0 d-flex align-items-center justify-content-start justify-content-md-end">
        <a class="ft-woyp" href="/whats-on-your-plate" aria-label="What's on Your Plate: ask a mate">
          <span class="ft-woyp-caps">What's on your</span>
          <span class="ft-woyp-plate">
            <span class="ft-woyp-hand">plate</span>
            <span class="ft-woyp-dots"><i></i><i></i><i></i></span>
          </span>
          <span class="ft-woyp-ask">ask a mate</span>
        </a>
      </div>
    </div>

    <div class="row px-3 mb-3">
      <div
        class="ps-0 col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pe-0 text-start text-lg-start mb-3 mb-lg-0"
      >
        <p class="ft-head">Find plates</p>
        <a href="/" class="mb-1 text-decoration-none d-block text-white">Search all private plates</a>
        <a href="/plates/current-style" class="mb-1 text-decoration-none d-block text-white">Registration series</a>
        <a href="/plates/dateless" class="mb-1 text-decoration-none d-block text-white">Dateless plates</a>
        <a href="/plates/initials" class="mb-1 text-decoration-none d-block text-white">Initials plates</a>
        <a href="/plates/name-plates" class="mb-1 text-decoration-none d-block text-white">Name plates</a>
        <a href="/plates/number-1" class="mb-1 text-decoration-none d-block text-white">Number 1 plates</a>
        <a href="/plates/budget/under-200" class="mb-1 text-decoration-none d-block text-white">Plates under £200</a>
        <a href="/plate-viewer" class="mb-1 text-decoration-none d-block text-white">See any plate on a car</a>
      </div>
      <div
        class="border-start border-light col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pe-0 ps-0 ps-md-3 text-start text-lg-start mb-3 mb-lg-0 no-border"
        style="border-color: #707070 !important"
      >
        <p class="ft-head">Guides</p>
        <a href="/guides" class="mb-1 text-decoration-none d-block text-white">All number plate guides</a>
        <a
          *ngFor="let guide of guides"
          href="/guides/{{ guide.slug }}"
          class="mb-1 text-decoration-none d-block text-white"
        >{{ guide.name }}</a
        >
      </div>
      <div
        class="border-start border-light col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pe-0 ps-0 ps-md-3 text-start text-lg-start mb-3 mb-lg-0 no-border"
        style="border-color: #707070 !important"
      >
        <p class="ft-head">Company</p>
        <a href="/about" class="mb-1 text-decoration-none d-block text-white">About PlateX</a>
        <a href="/blog" class="mb-1 text-decoration-none d-block text-white">Number Plate News</a>
        <a *ngIf="marketGuides" href="/market-guides" class="mb-1 text-decoration-none d-block text-white">Market Guides</a>
        <a
          class="mb-1 text-decoration-none d-block text-white"
          data-nosnippet
          href="mailto:info@platex.co.uk"
        >Contact us: info&#64;platex.co.uk</a
        >
      </div>
      <div
        class="border-start border-light col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 pe-0 ps-0 ps-md-3 text-start text-lg-start mb-3 mb-lg-0 no-border"
        style="border-color: #707070 !important"
      >
        <p class="ft-head">Legal</p>
        <a href="/privacy-policy" class="mb-1 text-decoration-none d-block text-white">Privacy Policy</a>
        <a href="/data-deletion" class="mb-1 text-decoration-none d-block text-white">Data Deletion</a>
        <a href="#" role="button" class="mb-1 text-decoration-none d-block text-white" data-nosnippet
          (click)="openCookiePreferences($event)">Cookie preferences</a>
      </div>
    </div>

    <div class="ft-feedback row px-3 mb-3">
      <div class="ps-0 col-12 d-flex flex-column flex-md-row align-items-start align-items-md-center gap-2 gap-md-3">
        <p class="mb-0 text-white">
          <strong>Help us improve PlateX.</strong>
          Spotted a wrong price, a broken link or something we could do better? Tell us.
        </p>
        <div class="d-flex gap-2">
          <button type="button" class="ft-fb-btn" (click)="openFeedback('footer-feedback')">Send feedback</button>
          <button type="button" class="ft-fb-btn" (click)="openFeedback('footer-report-problem')">Report a problem</button>
        </div>
      </div>
    </div>

    <div
      class="border-top border-light row px-3 py-3"
      style="border-color: #707070 !important"
    >
      <div class="col-md-5 col-12 ps-0">
        <p
          class="w-100 d-block fs-md-12 my-0 text-white text-center text-lg-start lh-base"
        >
          {{ (currentUrl === '/about' || currentUrl === '/about-us') ? 'PlateX is operated by Plate Tech Ltd, a company registered in England and Wales. Company Number: 16268508. Registered Office: 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ.' : 'Site Design & Build by PlateX' }}
        </p>
      </div>
      <div
        class="col-md-2 col-12 d-flex align-items-center justify-content-center gap-4 my-3 my-lg-0"
      >
        <a
          href="https://www.facebook.com/profile.php?id=100093000570664"
          style="max-width: 25px"
          class="d-block bg"
          target="_blank"
          rel="noopener"
          aria-label="PlateX on Facebook"
        >
          <object
            class="d-block mx-auto w-100"
            style="pointer-events: none"
            data="./../../../assets/facebook.svg"
          ></object>
        </a>

        <a
          href="https://www.instagram.com/plates"
          style="max-width: 25px"
          class="d-block"
          target="_blank"
          rel="noopener"
          aria-label="PlateX on Instagram"
        >
          <object
            class="d-block mx-auto w-100"
            style="pointer-events: none"
            data="./../../../assets/instagram.svg"
          ></object>
        </a>

<!--        <a-->
<!--          href="https://www.twitter.com/platex_uk"-->
<!--          style="max-width: 25px"-->
<!--          class="d-block"-->
<!--          target="_blank"-->
<!--        >-->
<!--          <object-->
<!--            class="d-block mx-auto w-100"-->
<!--            style="pointer-events: none"-->
<!--            data="./../../../assets/twitter.svg"-->
<!--          ></object>-->
<!--        </a>-->
      </div>
      <div class="col-md-5 col-12 pe-0">
        <p
          class="w-100 d-block fs-md-12 my-0 text-white lh-base text-center text-lg-end"
        >
          Copyright 2020 - {{ currYear }} PlateX
        </p>
      </div>
    </div>
  </div>
</div>
